import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntregaObraClienteFotografico1UseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_fotografico1_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";

/**
 * GetReportEntregaObraClienteFotografico1UseCase
 */

export class GetReportEntregaObraClienteFotografico1UseCase implements IGetReportEntregaObraClienteFotografico1UseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    retrabalhos?: string[],

  ): Promise<ReportData> {
    const response = await this.repository.getReportEntregaObraClienteFotografico1(
      requiredMimeType,
      idEntregaObraCliente,
      retrabalhos
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `entrega_obra_cliente_fotografico1_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;

  }
}
